import zod from 'zod';
import { TotvsIntegrationFormSchema } from '../../../services/IntegrationService/TotvsService/schemas';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import TextFieldComponent from '../../../components/TextFieldComponent';
import { Grid2 } from '@mui/material';
import ButtonComponent from '../../../components/ButtonComponent';
import {
  useCreateTotvsIntegrationAsync,
  useGetTotvsIntegrationByIdAsync,
  useUpdateTotvsIntegrationAsync,
} from '../../../services/IntegrationService/TotvsService/hooks/useMutation';
import CheckboxComponent from '../../../components/CheckboxComponent';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../../context/AppContextProvider';
import { ClipEscolaIntegrationFormSchema } from '../../../services/IntegrationService/ClipEscolaService/schemas';
import {
  useCreateClipEscolaIntegrationAsync, useGetClipEscolaIntegrationByIdAsync, useUpdateClipEscolaIntegrationAsync,
} from '../../../services/IntegrationService/ClipEscolaService/hooks/useMutation';


interface TotvsEditionFormProps {
  totvsIdToUpdate?: number;
  handleSaveForm?: () => void;
}

type ClipEscolaEditionFormInput = zod.infer<
  typeof ClipEscolaIntegrationFormSchema
>;

const ClipEscolaEditionForm = ({
  totvsIdToUpdate,
  handleSaveForm,
}: TotvsEditionFormProps) => {
  const { showSnackbar } = useContext(AppContext);
  const { control, handleSubmit, reset } = useForm<ClipEscolaEditionFormInput>({
    resolver: zodResolver(ClipEscolaIntegrationFormSchema),
    defaultValues: {
      name: '',
      token: '',
      description: '',
      isActive: true,
      roteIntegration: '',
      externalCode: '',
    },
  });

  const {
    mutate: mutateCreateTotvsIntegration,
    isLoading: isLoadingCreateTotvsIntegration,
  } = useCreateClipEscolaIntegrationAsync();
  const {
    mutate: mutateUpdateTotvsIntegration,
    isLoading: isLoadingUpdateTotvsIntegration,
  } = useUpdateClipEscolaIntegrationAsync();
  const {
    mutateAsync: mutateGetTotvsIntegrationByIdAsync,
    isLoading: isLoadingGetTotvsIntegrationById,
  } = useGetClipEscolaIntegrationByIdAsync();

  const handleSave = (data: ClipEscolaEditionFormInput) => {
    if (totvsIdToUpdate) {
      mutateUpdateTotvsIntegration(
        { id: totvsIdToUpdate, data },
        {
          onSuccess: () => {
            saveIntegration('Integração ClipEscola atualizada com sucesso.');
          },
        },
      );
      return;
    }
    mutateCreateTotvsIntegration(data, {
      onSuccess: () => {
        saveIntegration('Integração ClipEscola criada com sucesso.');
      },
    });
  };

  const saveIntegration = (message: string) => {
    reset();
    showSnackbar(message, 'success');
    if (handleSaveForm) handleSaveForm();
  };

  useEffect(() => {
    if (totvsIdToUpdate) {
      mutateGetTotvsIntegrationByIdAsync(totvsIdToUpdate).then((r) =>
        reset(r, { keepDefaultValues: true }),
      );
    }
  }, [totvsIdToUpdate]);

  return (
    <>
      <Grid2 container columnSpacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
                label="Nome"
              />
            )}
            name={'name'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
                label="Api Token"
              />
            )}
            name={'token'}
            control={control}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
                label="Rota de integração"
              />
            )}
            name={'roteIntegration'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
                label="Código externo"
              />
            )}
            name={'externalCode'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
                label="Descrição"
              />
            )}
            name={'description'}
            control={control}
          />
        </Grid2>
        <Grid2 size={12} sx={{ display: 'flex', justifyContent: 'right' }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <CheckboxComponent
                value={value}
                onChange={onChange}
                label="Ativo"
              />
            )}
            name={'isActive'}
            control={control}
          />
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <ButtonComponent
            fullWidth
            onClick={handleSubmit(handleSave)}
            loading={
              isLoadingCreateTotvsIntegration ||
              isLoadingGetTotvsIntegrationById ||
              isLoadingUpdateTotvsIntegration
            }
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </>
  );
};

export default ClipEscolaEditionForm;
